import { IconButton, SxProps, Tooltip } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import CheckIcon from '@mui/icons-material/Check'
import React from 'react'

interface EditButtonProps {
  dataTestId?: string
  title?: string
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void | (() => void)
  sx?: SxProps
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
  color?:
    | 'default'
    | 'primary'
    | 'inherit'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
  isEditMode?: boolean
  editTitle?: string
  saveTitle?: string
}

function EditButton({
                      title,
                      onClick,
                      sx,
                      placement = 'bottom',
                      color = 'primary',
                      dataTestId,
                      isEditMode = false,
                      editTitle = 'Edit sections order',
                      saveTitle = 'Exit edit mode'
                    }: Readonly<EditButtonProps>) {
  const buttonTitle = title ?? (isEditMode ? saveTitle : editTitle)

  return (
    <Tooltip title={buttonTitle} placement={placement}>
      <IconButton onClick={onClick} color={color} data-testid={dataTestId}>
        {isEditMode ? <CheckIcon sx={sx} /> : <EditIcon sx={sx} />}
      </IconButton>
    </Tooltip>
  )
}

export default EditButton
